import ToDo from '@/Apis/ToDo'
import Announcements from '../Apis/Announcements'
import Auth from '../Apis/Auth'
import EduPrograms from '../Apis/Edu_programs'
import Polls from '../Apis/Polls'

export default class HomeController {
  async StudentHome(id) {
    const data = {}
    let ed = new EduPrograms()
    data.programStatistics = await ed.ProgramStatistics(id);
    let eduProgramId= localStorage.getItem("eduProgram")
    let roomId=Auth.ROOM.find(a=>a.edu_program_id==eduProgramId)
    
    data.announcements = await new Announcements().HomeAnnouncements({edu_program_id:eduProgramId,room_id:roomId.id});
    data.polls = await new Polls().HomePolls()
    data.toDo = await new ToDo().GetAll();

    return data
  }
}
